var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99853 5.99991V8.66658M7.99853 11.3332H8.0052M7.07541 2.59439L1.59216 12.0655C1.28802 12.5908 1.13595 12.8535 1.15843 13.069C1.17803 13.2571 1.27654 13.4279 1.42945 13.5391C1.60475 13.6666 1.90826 13.6666 2.51528 13.6666H13.4818C14.0888 13.6666 14.3923 13.6666 14.5676 13.5391C14.7205 13.4279 14.819 13.2571 14.8386 13.069C14.8611 12.8535 14.709 12.5908 14.4049 12.0655L8.92166 2.59439C8.61861 2.07095 8.46709 1.80923 8.2694 1.72132C8.09696 1.64465 7.90011 1.64465 7.72767 1.72132C7.52998 1.80923 7.37846 2.07095 7.07541 2.59439Z",
    stroke: "#EC221F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.e599a81cd4ec27e53d11deb86c8214a0.svg";
export { ForwardRef as ReactComponent };